import React, {useEffect, useState} from "react";
import {useLoaderData, useNavigation, useOutletContext} from "react-router-dom";
import {parseHtmlString, getTitleColor} from "../../utils";
import {Grid, View} from "@aws-amplify/ui-react";
import styles from "./index.module.css";
import TopicsList from "../../components/TopicsList";
import GlobalAlert from "../../components/GlobalAlert";
import Loading from "../../components/Loading";
import LicenseWarning from "../../components/LicenseWarning";

const Topic = () => {
  const [missingLicense, setMissingLicense] = useState(false);

  const {
    courseId = 0,
    lessonId = 0,
    topicId = 0,
    error,
    topic = {},
  } = useLoaderData();

  const {
    lesson = {},
  } = useOutletContext();

  const {
    topics = [],
  } = lesson || {}

  const {
    id = 0,
    description = "",
    title = "",
    cover = "",
  } = topic || {};

  const scrolledRef = React.useRef(false);

  useEffect(() => {
    if (window.sessionStorage.getItem("missing_license")) {
      setMissingLicense(true);
    } else {
      setMissingLicense(false);
    }

    setTimeout(() => {
      const element = document.getElementById("topic");
      if (element) {
        element.scrollIntoView({block: "start", inline: "nearest", behavior: 'smooth'});
        scrolledRef.current = true;
      }
    }, 100);
  }, [topicId]);

  const titleClassNames = [styles.topicTitle, getTitleColor(courseId)]

  const navigation = useNavigation();

  if (navigation.state === "loading") {
    return <Loading/>
  }

  return (
    <Grid
      id="topic"
      templateColumns={{base: "1fr", medium: "2fr 1fr", large: "4fr 1fr"}}
      templateRows={{base: "repeat(3, auto)", medium: "30vh auto"}}
      className={styles.mainGrid}
    >
      {
        !!error &&
        <GlobalAlert
          heading={error.toString()}
          variation="error"
        />
      }
      <View
        position="relative"
        backgroundImage={`url(${cover})`}
        className={styles.titleViewWrapper}
        columnSpan={[1, 1, 2, 2]}
      >
        <Grid
          templateColumns={{base: "1fr", large: "4fr 1fr"}}
          templateRows={{base: "auto", large: "30vh"}}
        >
          <View className={styles.topicTitleWrapper}>
            <View className={styles.topicTitleContainer}>
              <h2 className={titleClassNames.join(' ')}>
                {title}
              </h2>
            </View>
          </View>
        </Grid>
      </View>

      <View className={styles.contentViewWrapper}>
        {parseHtmlString(description)}
        {
          missingLicense &&
          <LicenseWarning/>
        }
      </View>

      <View className={styles.siderViewWrapper}>
        <TopicsList
          courseId={courseId}
          lessonId={lessonId}
          topics={topics}
          currentTopicId={id}
        />
      </View>
    </Grid>
  );
}

export default Topic;